exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add[data-v-51da357e] {\n    cursor: pointer;\n}\n.add[data-v-51da357e]:hover {\n    box-shadow: 1px 1px 5px #263516;\n    background: #8bf768;\n    color: #137924;\n}\n", ""]);

// exports
